import React from 'react'
import StudentCourses from '../../components/student/Courses'
import Header from '../../components/Header'
import SideNav from '../../components/student/Sidenav'
function Courses() {
  return (
    <div>
    <Header/>
    <SideNav/>
    <StudentCourses/>
    </div>
  )
}

export default Courses
